import React from 'react';
import { Modal } from 'react-bootstrap';
import { Warning48Filled } from '@fluentui/react-icons';
import styles from './DoubleConfirmationModal.module.css';

/**
 * A-06 / A-09 / A-10 — Pause / Cancel / Resume confirmations.
 * Spec buttons (exactly two) — no third Cancel dismiss button.
 */
const PauseTaskConfirmModal = ({
    open,
    onClose,
    onThisOnly,
    onWithFollowing,
    confirmLoading = false,
    action = 'pause', // 'pause' | 'cancel' | 'resume'
    selectedCount = 0,
}) => {
    const isResume = action === 'resume';
    const isCancel = action === 'cancel';
    const bulkPrefix = selectedCount > 1 ? `${selectedCount} selected tasks — ` : '';

    const title = isResume ? 'Resume Schedule?' : isCancel ? 'Cancel Task' : 'Pause Task';
    const message = isResume
        ? `${bulkPrefix}Resume only the selected task(s), or resume and recalculate all subsequent scheduled tasks?`
        : isCancel
          ? `${bulkPrefix}Cancel only the selected task(s), or cancel them and all subsequent scheduled tasks?`
          : `${bulkPrefix}Pause only the selected task(s), or pause them and all subsequent scheduled tasks?`;

    const thisOnlyLabel = isResume ? 'Resume only this task' : isCancel ? 'Cancel only this task' : 'Pause only this task';
    const followingLabel = isResume
        ? 'Resume and recalculate downstream'
        : isCancel
          ? 'Cancel this task and downstream tasks'
          : 'Pause this task and downstream tasks';

    return (
        <Modal centered show={open} onHide={onClose} className={styles.modalMainBody}>
            <Modal.Body className={styles.confirmationModalBody}>
                <div className={styles.confirmationModalMsg}>
                    <div className="mb-4 text-center">
                        <Warning48Filled color="var(--Brand-Primary)" />
                    </div>
                    <h3 style={{ textAlign: 'center', fontSize: 20, fontWeight: 600, marginBottom: 16 }}>{title}</h3>
                    <p className={styles.message} style={{ marginBottom: 34 }}>
                        {message}
                    </p>
                    <div className="d-flex flex-column gap-3">
                        <span
                            role="button"
                            tabIndex={0}
                            onClick={() => {
                                if (!confirmLoading) onThisOnly();
                            }}
                            onKeyDown={e => {
                                if ((e.key === 'Enter' || e.key === ' ') && !confirmLoading) onThisOnly();
                            }}
                            className={styles.orangeLink}
                            style={{
                                opacity: confirmLoading ? 0.6 : 1,
                                pointerEvents: confirmLoading ? 'none' : 'auto',
                                textAlign: 'center',
                            }}>
                            {thisOnlyLabel}
                        </span>
                        <span
                            role="button"
                            tabIndex={0}
                            onClick={() => {
                                if (!confirmLoading) onWithFollowing();
                            }}
                            onKeyDown={e => {
                                if ((e.key === 'Enter' || e.key === ' ') && !confirmLoading) onWithFollowing();
                            }}
                            className={styles.orangeLink}
                            style={{
                                opacity: confirmLoading ? 0.6 : 1,
                                pointerEvents: confirmLoading ? 'none' : 'auto',
                                textAlign: 'center',
                            }}>
                            {followingLabel}
                        </span>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default PauseTaskConfirmModal;
